import React, { useState } from 'react';
import useFetchListingBuildingPermits from '@th/frontend-shared/src/hooks/queries/useFetchListingBuildingPermits';
import SvgIcon from '../icons/SvgIcon';
import PermitRevisionGroupInfo from '../buildingPermits/PermitRevisionGroupInfo';

type Props = {
  listingId: string;
};

const DEFAULT_NUM_TO_SHOW = 2;

export default function ListingBuildingPermits({ listingId }: Props) {
  const { permitRevisionGroups, isLoading } =
    useFetchListingBuildingPermits(listingId);

  const [isShowingAll, setIsShowingAll] = useState(false);
  const numToShow = isShowingAll
    ? permitRevisionGroups.length
    : DEFAULT_NUM_TO_SHOW;

  if (permitRevisionGroups.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="mb-4">Building Permit History</h3>
      {permitRevisionGroups
        .slice(0, numToShow)
        .map((permitRevisionGroup, index) => {
          return (
            <PermitRevisionGroupInfo
              permitRevisionGroup={permitRevisionGroup}
              key={index}
              showAddress={false}
              containerClassName="border border-lightGray rounded-lg py-2 px-4 my-2"
              rowClassName="mb-1"
            />
          );
        })}
      {permitRevisionGroups.length > DEFAULT_NUM_TO_SHOW && (
        <div
          className="flex border border-lightGray bg-lightGray rounded-lg py-2 px-4 my-1 cursor-pointer"
          onClick={() => {
            setIsShowingAll(val => !val);
          }}
        >
          <div className="mr-2">
            {isShowingAll
              ? `Hide extra permits`
              : `Show all ${permitRevisionGroups.length} permits`}
          </div>
          <SvgIcon name={isShowingAll ? 'HiChevronUp' : 'HiChevronDown'} />
        </div>
      )}
    </div>
  );
}
